<template>
  <div class="dg__upload " :class="{ inline: inline }">
    <div class="relative inline-block upload-box">
      <div v-if="$slots.default && !button">
        <slot></slot>
        <slot name="preview"></slot>
      </div>
      <div v-if="!$slots.default && !button" class="img-upload flex">
        <i class="icon" v-show="!url">&#xe60b;</i>
        <img class="preview" :src="url" v-show="url" />
      </div>
      <el-button type="primary" :size="buttonSize" v-if="button" @click="clicktest">
        <slot></slot>
      </el-button>
      <input ref="fileRef" id="fileRef" class="file-input dg__upload_input" type="file"
        :accept="type.toString()" @change="upfile" />
    </div>
    <!-- <div v-if="url && !noUpload">
      <a style="vertical-align: middle" :href="url" class="aui-inline" target="_blank">
        <p :class="{ inline: inline }" class="url-box aui-ellipsis-1"><i class="icon">&#xe74f;</i> {{ url }}</p>
      </a>
      <i class="icon cursor-pointer pl-[6]" @click="hanldeDel">&#xe641;</i>
    </div>
    <p class="tip">{{ tips }}</p> -->
  </div>
</template>

<script>
export default {
  name: "dg-void-upload",
  inject: ["elForm"],
  props: {
    noUpload: Boolean,
    value: String,
    model: Array,
    tip: String,
    buttonSize: {
      type: String,
      default: "small"
    },
    size: Number,
    accept: {
      type: String,
       default: "image/png, image/jpeg, image/jpg, .pdf, .doc, .docx, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    },
    type: {
      type: Array,
      default: () => {
         return [".jpg", ".jpeg", ".png",'.docx','.doc','.pdf'];
      }
    },
    button: Boolean,
    inline: Boolean
  },
  data() {
    return {
      url: "",
      tips: "仅限上传一张图片，大小不超过5M"
    };
  },
  watch: {
    value: {
      handler(val) {
        this.url = val;
      },
      immediate: true
    },
    tip: {
      handler(val) {
        this.tips = val;
      },
      immediate: true
    }
  },
  methods: {
    clicktest() {
      this.$refs.fileRef.dispatchEvent(new MouseEvent('click'))
    },
    /**
     * @author 伟健 / 张
     * @name 删除
     * @param
     * @return
     */
    hanldeDel() {
      this.url = "";
      this.$emit("change", { url: "", name: "" });
      this.$emit("input", "");
      // if (formItem) {
      //   formItem.validate("change").catch(err => debugWarn(err));
      // }
    },
    upfile(e) {
      var file = e.target.files[0]; //获取上传的文件
      let { size, name } = file;

      var suffix = this.getSuffix(name);
      var maxSize = 1048576 * this.size; //最大5MB
      if (size > maxSize) {
        // this.$message({
        //   message: `上传的文件不能超过${this.size}MB`,
        //   type: "error"
        // });
        this.$emit("fileError", `上传的文件不能超过${this.size}MB`);
        return;
      }
      if (this.type.length && this.type.indexOf(suffix) == -1 && this.type[0] != "*") {
        // this.$message({
        //   message: `文件类型错误,请上传${this.type.join(" ")}`,
        //   type: "error"
        // });
        this.$emit("fileError", `文件类型错误,请上传${this.type.join(" ")}`);
        return;
      }
      var formData = new FormData();
      formData.append("fileName", file);
      this.$emit("file", file);
      if (this.noUpload) {
        return;
      }
      this.$emit('handleLoading', true)
      ajax.uploadFile({
        url: "/customer/upload",
        data: formData,
        timeout:300000,
        self: this,
        success: res => {
          if (res) {
            this.$emit('handleNoLoading', false)
            this.$emit("change", { url: res, name: name });
            // this.$emit("input", res);

            // this.elForm.clearValidate(this.elFormItem.prop);
            // this.url = res;
          }
          e.target.value = "";
        },
        fail: () => {
          e.target.value = "";
          this.$message({ message: `图片上传失败`, type: "error" });
          this.$emit('handleNoLoading', false)
        }
      });
    },
    getSuffix(str) {
      var d = str.split(".");
      return "." + d[d.length - 1];
    }
  },
  mounted() {
  }
};
</script>

<style lang="less" scoped>
.dg__upload {
  line-height: normal;

  &.inline {
    display: inline-block;
    margin-right: 10px;
    vertical-align: top;
  }

  .file-input {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 5;
    cursor: pointer;
    opacity: 0;
  }

  .preview {
    position: absolute;
    top: 1%;
    left: 1%;
    width: 98%;
    height: 98%;
    object-fit: cover;
    object-position: center;
    display: block;
    border-radius: 4px;
  }

  .url-box {
    // width: 200px;
    color: #c7c7c7;
    font-size: 12px;
    padding-top: 5px;

    &.inline {
      width: 170px;
    }
  }

  a:hover {
    text-decoration: underline;
    color: #c7c7c7;
  }
}

.img-upload {
  width: 100px;
  height: 100px;
  border-radius: 4px;
  border: 1px dashed #c7c7c7;
  cursor: pointer;

  i {
    margin: auto;
    font-size: 30px;
    color: #c7c7c7;
  }
}

.tip {
  font-size: 12px;
  color: #c7c7c7;
  padding-top: 5px;
}
</style>
